var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.582031 10.0391C0.582031 9.75 0.683594 9.50391 0.886719 9.30078C1.09766 9.08984 1.34375 8.98438 1.625 8.98438H9.20703V1.41406C9.20703 1.13281 9.30859 0.890625 9.51172 0.6875C9.71484 0.476562 9.96094 0.371094 10.25 0.371094C10.5391 0.371094 10.7852 0.476562 10.9883 0.6875C11.1992 0.890625 11.3047 1.13281 11.3047 1.41406V8.98438H18.875C19.1562 8.98438 19.3984 9.08984 19.6016 9.30078C19.8125 9.50391 19.918 9.75 19.918 10.0391C19.918 10.3281 19.8125 10.5742 19.6016 10.7773C19.3984 10.9805 19.1562 11.082 18.875 11.082H11.3047V18.6641C11.3047 18.9453 11.1992 19.1875 10.9883 19.3906C10.7852 19.6016 10.5391 19.707 10.25 19.707C9.96094 19.707 9.71484 19.6016 9.51172 19.3906C9.30859 19.1875 9.20703 18.9453 9.20703 18.6641V11.082H1.625C1.34375 11.082 1.09766 10.9805 0.886719 10.7773C0.683594 10.5742 0.582031 10.3281 0.582031 10.0391Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a37f9cc09aa0919bb47ba396fee5e811.svg";
export { ForwardRef as ReactComponent };